import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  Grid,
  ButtonBase,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { APPIMAGE_BASE_URL } from "../../config/constants";
import { COUPON_RULES } from "../../config/constantselections";

const colors = ["#FFF5E1"]; // Light warm background

const CouponDrawerMenu = ({ open, availableCoupons = [], onClose }) => {
  const [currentColorIndex, setCurrentColorIndex] = useState(0);

  useEffect(() => {
    const colorInterval = setInterval(() => {
      setCurrentColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 10000);

    return () => clearInterval(colorInterval);
  }, []);

  const generalCoupons = availableCoupons.filter(
    (c) => c.category === "GENERAL"
  );

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "20%",
          height: "95%",
          borderTopRightRadius: "20px",
          borderBottomRightRadius: "20px",
          paddingTop: "60px",
          paddingBottom: "80px",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "absolute",
          top: 10,
          left: 0,
          width: "100%",
          padding: "12px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "white",
          zIndex: 10,
        }}
      >
        <Typography
          sx={{ fontSize: 18, fontWeight: "bold", textTransform: "uppercase" }}
        >
          Available Coupons
        </Typography>
        <CloseIcon onClick={onClose} sx={{ cursor: "pointer" }} />
      </Box>

      {/* Coupon Tiles */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          paddingX: 2,
          marginTop: "10px",
        }}
      >
        <Grid container spacing={2}>
          {generalCoupons.map((coupon) => (
            <Grid item xs={12} key={coupon.id}>
              <ButtonBase
                onClick={() => {
                  window.location.href = `/coupon/${coupon.id}`;
                  onClose();
                }}
                sx={{
                  width: "100%",
                  backgroundColor: colors[currentColorIndex],
                  color: "#000",
                  padding: "16px",
                  borderRadius: "16px",
                  border: "2px dashed #aaa",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    marginBottom: "6px",
                  }}
                >
                  {coupon.name}
                </Typography>
                <Typography
  sx={{
    fontSize: 14,
    color: "#444",
    fontStyle: "italic",
  }}
>
  {
    (COUPON_RULES.find(rule => rule.value === coupon.rule)?.label) || coupon.rule
  }
</Typography>
              </ButtonBase>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Bottom Promo */}
      <Box
        sx={{
          position: "absolute",
          bottom: 50,
          left: 0,
          width: "100%",
          height: "100px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={`${APPIMAGE_BASE_URL}/appimages/collection.png`}
          alt="Promo"
          style={{ width: "70%", objectFit: "contain" }}
        />
      </Box>
    </Drawer>
  );
};

export default CouponDrawerMenu;
